var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlowTireLeak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 8,
    height: 16,
    rx: 2,
    fill: "#102B4E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 12,
    width: 8,
    height: 16,
    rx: 2,
    fill: "#102B4E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 46,
    width: 8,
    height: 16,
    rx: 2,
    fill: "#102B4E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 46,
    width: 8,
    height: 16,
    rx: 2,
    fill: "#102B4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0005 8C40.6671 8 45.3336 9.16667 49.5557 11.2667C50.6668 11.9667 51.5557 13.3667 51.5557 15V26.6667H56V31.3333H51.5557V58.8667C51.5557 60.7333 50.0002 62.6 48.4446 62.8333C46.8891 63.0667 40.4448 64 36.0005 64C31.5562 64 25.5563 63.3 23.5564 62.8333C21.5565 62.3667 20.4454 60.9667 20.4454 58.8667V31.3333H16.001V26.6667H20.4454V15C20.4454 13.6 21.3342 12.2 22.4453 11.5C26.6674 9.16667 31.334 8 36.0005 8ZM36.0005 12.6667C32.0006 12.6667 28.2229 13.6 24.8897 15.2333V58.1667C28.4452 58.8667 32.2228 59.1 36.0005 59.1C39.7782 59.1 43.5559 58.8667 47.1113 58.1667V15.2333C43.7781 13.6 40.0004 12.6667 36.0005 12.6667ZM41.1115 47.6667C42.0004 47.6667 42.667 48.3667 42.667 49.3V53.2667L42.5626 53.3223C42.0548 53.5825 39.716 54.6667 36.0005 54.6667C32.2851 54.6667 29.9463 53.5825 29.4385 53.3223L29.3457 53.2732L29.334 49.3C29.334 48.3667 30.0007 47.6667 31.1118 47.6667H41.1115ZM36.0005 24.3333C39.716 24.3333 42.0548 25.4175 42.5626 25.6777L42.6553 25.7268L42.667 29.7C42.667 30.6333 42.0004 31.3333 40.8893 31.3333H30.8895C30.0007 31.3333 29.334 30.6333 29.334 29.7V25.7333L29.4385 25.6777C29.9463 25.4175 32.2851 24.3333 36.0005 24.3333Z",
    fill: "#102B4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlowTireLeak);
export default __webpack_public_path__ + "static/media/slow-tire-leak.c411ceaef61f6b362e9229ef6a0e50ee.svg";
export { ForwardRef as ReactComponent };